import React from 'react';
import Btn, { BtnModifier } from '../../../components/molecules/Btn';
import { Badge, BadgeModifier } from '../../../_lib/components/Badge';
import { useSonTranslation } from '../../../translation/useSonTranslation';

interface SwitchButtonsProps {
  searchLinks: Record<string, { url: string; count: number }>;
  currentType: 'content' | 'user';
}

export function SearchFormSwitchButtons({ searchLinks, currentType }: SwitchButtonsProps) {
  const { t } = useSonTranslation('SearchForm');

  if (!searchLinks) {
    return null;
  }

  return (
    <div className="search-form__switching-buttons">
      <h3 className="invisible">{t('search.moreResults')}</h3>
      {Object.entries(searchLinks).map(([key, link]) => {
        const badgeTitle =
          link.count > 1 || link.count === 0 ? t('search.results_plural') : t('search.results', { count: link.count });
        const linkName = t(`search.type.${key as 'content' | 'user'}`) + ' ' + link.count + ' ' + badgeTitle;

        return (
          <div key={key} className="search-form__switching-button">
            <Btn
              href={key === currentType ? undefined : link.url}
              modifier={key === currentType ? BtnModifier.ACTIVE : undefined}
              disabledLink={key === currentType}
              ariaCurrent={key === currentType ? 'page' : undefined}
              ariaLabel={linkName}
            >
              <span className="search-form__switching-button-content">
                <span className="search-form__switching-button-content-text">
                  {t(`search.type.${key as 'content' | 'user'}`)}
                </span>
                <span className="search-form__switching-button-badge" aria-hidden="true">
                  <Badge
                    modifier={
                      key === currentType
                        ? [BadgeModifier.CONTENT, BadgeModifier.CONTENT_ACTIVE]
                        : BadgeModifier.CONTENT
                    }
                    title={`${link.count} ${badgeTitle}`}
                  >
                    <span className="search-form__switching-button-badge-count font-light-12-12">{link.count}</span>
                    <span className="invisible">{badgeTitle}</span>
                  </Badge>
                </span>
              </span>
            </Btn>
          </div>
        );
      })}
    </div>
  );
}
